// extracted by mini-css-extract-plugin
export default {"subscription_item_price":"hC","delete_item":"iC","subscription_item":"jC","subscription_item_img_wrapper":"kC","subscription_item_info":"lC","subscription_item_title":"mC","subscription_item_edit":"nC","subscription_item_wrapper":"oC","arrow":"pC","subscription_item_category":"qC","plus_button":"rC","more_details":"sC","old_price":"tC","discount":"uC"};
    if(module.hot) {
      // 1738064241553
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  